import { render } from "./index.vue?vue&type=template&id=d122aada&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d122aada&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d122aada"],['__file',"src/components/dbTable/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d122aada"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d122aada', __exports__)) {
    api.reload('d122aada', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d122aada&scoped=true", () => {
    api.rerender('d122aada', render)
  })

}


export default __exports__